<template>
  <v-popover
      placement="bottom"
      offset="11"
      open-group="space-remove-popover"
      popoverClass="space-remove-popover">
    <BaseButton size="xs" theme="red-outline" class="group" @click="confirmation=true">
      <IconTrash class="text-icon group-hover:text-white mr-4"/>
      <span>
        {{ $t('removeSpace') }}
      </span>
    </BaseButton>
    <template slot="popover">
      <div class="col-span-2">
        <div class="mb-4 text-lg font-bold text-text">
          {{ $t('attention') }}
        </div>
        <p class="mb-5 text-text text-2sm text-left" v-html="$t('attentionText', {title:space.title})"></p>
        <BaseInput v-model="spaceTitleConfirmation"/>
      </div>

      <BaseButton theme="red" @click="apply"
                  v-close-popover
                  :disabled="spaceTitleConfirmation !== space.title"
                  :loading="inProgress">
        {{ $t('delete') }}
      </BaseButton>
      <BaseButton theme="white" v-close-popover @click="cancel">
        {{ $t('cancel') }}
      </BaseButton>
      <div class="col-span-2 grid grid-cols-2 cols-gap-6">
      </div>
    </template>
  </v-popover>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import BaseButton from '@/components/UI/BaseButton.vue';
import IconTrash from "@/components/icons/IconTrash";
import BaseInput from "@/components/UI/BaseInput/BaseInput";

export default {
  name: "ArchiveBtn",
  components: {
    BaseInput,
    IconTrash,
    BaseButton
  },
  props: {
    space: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      confirmation: false,
      inProgress: false,
      spaceTitleConfirmation: ''
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('cabinet/user', ['user_info']),
    ...mapGetters('space', ['spacesList']),
  },
  methods: {
    ...mapActions('space', ['archiveSpace']),
    ...mapActions('cabinet', ['forwardUserFromDeletedSpace']),
    ...mapActions('cabinet/user', ['setUserPrimarySpaceId']),

    ...mapMutations('space', ['removeSpace']),
    async apply() {
      const {id, title} = this.space;
      this.inProgress = true;
      try {
        const {body} = await this.archiveSpace(id)
        if (body.success) {
          this.inProgress = false;
          this.removeSpace(id);
          this.forwardUserFromDeletedSpace();
          this.$toasted.error(`Мы успешно удалили ${title}`);
        }
      } catch (e) {
        console.warn(e);
      }
    },
    cancel() {
      this.spaceTitleConfirmation = ''
      this.inProgress = false
      this.confirmation = false
    }
  },
  i18n: {
    messages: {
      en: {
        removeSpace: 'Delete workspace',
        attention: 'ATTENTION!',
        attentionText: 'Are you sure you want to completely remove the workspace <strong>«{title}»</strong>?\n'
            + '<br><br>If you delete the workspace, all your data will be lost.\n'
            + '<br><br>To confirm, enter the workspace name in the field below:',
        delete: 'Delete',
        cancel: 'Cancel'
      },
      ru: {
        removeSpace: 'Удалить пространство',
        attention: 'ВНИМАНИЕ!',
        attentionText: 'Вы уверены, что хотите полностью удалить пространство <strong>«{title}»</strong>?\n' +
            '<br><br>Если удалите пространство, все ваши данные будут утеряны.\n' +
            '<br><br>Чтобы подтвердить удаление, введите название пространства в поле ниже:',
        delete: 'Удалить',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.tooltip.popover.space-remove-popover {
  &:before {
    position: fixed;
    content: '';
  }

  &:focus {
    @apply outline-none;
  }

  .popover-inner {
    @apply p-4 bg-block shadow-primaryBlock rounded;
    width: 400px;
    z-index: 2;

    > div {
      @apply grid grid-cols-2 col-gap-4 row-gap-4;
    }
  }

  &[x-placement^="top"] {
    .popover-arrow {
      border-width: .8rem .8rem 0 .8rem;
      bottom: -.8rem;
    }
  }

  &[x-placement^="bottom"] {
    .popover-arrow {
      top: -.8rem;
      border-width: 0 .8rem .8rem .8rem;
    }
  }

  .popover-arrow {
    @apply border-block;
    z-index: 1;
    filter: drop-shadow(0px 4px 8px rgba(86, 114, 155, 0.6));

  }
}
</style>